<script setup>
import {reactive, computed, onMounted} from 'vue';
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {Permissions} from "@/Utils/Permissions";
import {ToastUtil} from "@/Utils/ToastUtil";


  const data = reactive({
    loading: false,
    dataLoading: true,
    isDisabled: false,

    // Used for select dropdowns (Filled in via API calls)
    catcodes: [],
    companies: [],
    clients: [],

    // Dropdown options
    cycleReportTypes: [
      {title: 'By Adjuster', key: 'adjuster'},
      {title: 'By Writer', key: 'writer'},
      {title: 'By Account Manager', key: 'account-manager'},
      {title: 'By Reviewer', key: 'reviewer'},
      {title: 'By Review TM', key: 'review-team-manager'},
      {title: 'By Month', key: 'month'},
      {title: 'By State', key: 'state'},
      {title: 'By Company', key: 'client'}
    ],
    datePresets: [
      {title: 'This Month', key: 'this-month'},
      {title: 'Last Month', key: 'last-month'},
      {title: 'Previous Month', key: 'previous-month'},

      {title: 'This Year', key: 'this-year'},
      {title: 'Last Year', key: 'last-year'},
      {title: 'Previous Year', key: 'previous-year'},

      {title: 'Custom Range', key: 'custom'}
    ],
    states: [
      {
        "name": "Alabama",
        "abbreviation": "AL",
        salesTax: false
      },
      {
        "name": "Alaska",
        "abbreviation": "AK",
        salesTax: false
      },
      {
        "name": "Arizona",
        "abbreviation": "AZ",
        salesTax: false
      },
      {
        "name": "Arkansas",
        "abbreviation": "AR",
        salesTax: false
      },
      {
        "name": "California",
        "abbreviation": "CA",
        salesTax: false
      },
      {
        "name": "Colorado",
        "abbreviation": "CO",
        salesTax: false
      },
      {
        "name": "Connecticut",
        "abbreviation": "CT",
        salesTax: false
      },
      {
        "name": "Delaware",
        "abbreviation": "DE",
        salesTax: false
      },
      {
        "name": "DC",
        "abbreviation": "DC",
        salesTax: false
      },
      {
        "name": "Florida",
        "abbreviation": "FL",
        salesTax: false
      },
      {
        "name": "Georgia",
        "abbreviation": "GA",
        salesTax: false
      },
      {
        "name": "Hawaii",
        "abbreviation": "HI",
        salesTax: true
      },
      {
        "name": "Idaho",
        "abbreviation": "ID",
        salesTax: false
      },
      {
        "name": "Illinois",
        "abbreviation": "IL",
        salesTax: false
      },
      {
        "name": "Indiana",
        "abbreviation": "IN",
        salesTax: false
      },
      {
        "name": "Iowa",
        "abbreviation": "IA",
        salesTax: false
      },
      {
        "name": "Kansas",
        "abbreviation": "KS",
        salesTax: false
      },
      {
        "name": "Kentucky",
        "abbreviation": "KY",
        salesTax: false
      },
      {
        "name": "Louisiana",
        "abbreviation": "LA",
        salesTax: false
      },
      {
        "name": "Maine",
        "abbreviation": "ME",
        salesTax: false
      },
      {
        "name": "Maryland",
        "abbreviation": "MD",
        salesTax: false
      },
      {
        "name": "Massachusetts",
        "abbreviation": "MA",
        salesTax: false
      },
      {
        "name": "Michigan",
        "abbreviation": "MI",
        salesTax: false
      },
      {
        "name": "Minnesota",
        "abbreviation": "MN",
        salesTax: false
      },
      {
        "name": "Mississippi",
        "abbreviation": "MS",
        salesTax: false
      },
      {
        "name": "Missouri",
        "abbreviation": "MO",
        salesTax: false
      },
      {
        "name": "Montana",
        "abbreviation": "MT",
        salesTax: false
      },
      {
        "name": "Nebraska",
        "abbreviation": "NE",
        salesTax: false
      },
      {
        "name": "Nevada",
        "abbreviation": "NV",
        salesTax: false
      },
      {
        "name": "New Hampshire",
        "abbreviation": "NH",
        salesTax: false
      },
      {
        "name": "New Jersey",
        "abbreviation": "NJ",
        salesTax: false
      },
      {
        "name": "New Mexico",
        "abbreviation": "NM",
        salesTax: true
      },
      {
        "name": "New York",
        "abbreviation": "NY",
        salesTax: false
      },
      {
        "name": "North Carolina",
        "abbreviation": "NC",
        salesTax: false
      },
      {
        "name": "North Dakota",
        "abbreviation": "ND",
        salesTax: false
      },
      {
        "name": "Ohio",
        "abbreviation": "OH",
        salesTax: false
      },
      {
        "name": "Oklahoma",
        "abbreviation": "OK",
        salesTax: false
      },
      {
        "name": "Oregon",
        "abbreviation": "OR",
        salesTax: false
      },
      {
        "name": "Pennsylvania",
        "abbreviation": "PA",
        salesTax: false
      },
      {
        "name": "Rhode Island",
        "abbreviation": "RI",
        salesTax: false
      },
      {
        "name": "South Carolina",
        "abbreviation": "SC",
        salesTax: false
      },
      {
        "name": "South Dakota",
        "abbreviation": "SD",
        salesTax: true
      },
      {
        "name": "Tennessee",
        "abbreviation": "TN",
        salesTax: false
      },
      {
        "name": "Texas",
        "abbreviation": "TX",
        salesTax: false
      },
      {
        "name": "Utah",
        "abbreviation": "UT",
        salesTax: false
      },
      {
        "name": "Vermont",
        "abbreviation": "VT",
        salesTax: false
      },
      {
        "name": "Virginia",
        "abbreviation": "VA",
        salesTax: false
      },
      {
        "name": "Washington",
        "abbreviation": "WA",
        salesTax: false
      },
      {
        "name": "West Virginia",
        "abbreviation": "WV",
        salesTax: true
      },
      {
        "name": "Wisconsin",
        "abbreviation": "WI",
        salesTax: false
      },
      {
        "name": "Wyoming",
        "abbreviation": "WY",
        salesTax: false
      }
    ],

    // Dropdown selections
    selectedClient: '',
    cycleReportType: 'state',
    datePreset: 'this-month',
    report: null,
    stateSalesTaxStateSelection: '',
    stateSelection: [],
    selectedCATCode: '',
    selectedCompany: null,
    selectedCompanyBilling: '',

    // Date selection
    dates: [],
    date: new Date(),

    // List of all available reports and the permissions needed to generate them
    reports: [
      {
        name: 'Adjuster Daily Report',
        permission: 'reports.report-data'
      },
      {
        name: 'Aging Receivables Report',
        permission: 'reports.aging-receivables'
      },
      {
        name: 'Billing Report',
        permission: 'reports.billing'
      },
      {
        name: 'CAT Code Report',
        permission: 'reports.cat-code'
      },
      {
        name: 'Disbursement Totals Report',
        permission: 'reports.disbursement-totals'
      },
      {
        name: 'Open Claims Report',
        permission: 'reports.open-claims'
      },
      {
        name: 'MetLife Prior Loss Report',
        permission: 'reports.met-life'
      },
      {
        name: 'Mileage Expenses and Disbursements Report',
        permission: 'reports.mileage-expenses-and-disbursements'
      },
      /*
      Note: Commenting this out for now, if it is used when can readdress. But it is pulling over 500k rows which takes awhile for the query and crashes the csv generation
      {
        name: 'Contact List Report',
        permission: 'reports.contact-list'
      },
      */
      {
        name: 'Payments Report',
        permission: 'reports.payments'
      },
      {
        name: 'Invoices Report',
        permission: 'reports.invoices'
      },
      {
        name: 'State Sales Tax Report',
        permission: 'reports.state-sales-tax'
      },
      {
        name: 'Cycle Time Report',
        permission: 'reports.cycle-time'
      }
    ],

    // Used to filter reports by name
    search: ''
  });

  const dateRange = () => {
    if (Array.isArray(data.dates)) {
      let datesArr = data.dates.map((date) => {
        let d = new Date(`${date}`);
        d.setHours(0, 0, 0, 0);
        return d;
      }).sort((a,b) => Date.parse(a) - Date.parse(b));

      if(datesArr.length === 0) {
        return [];
      }
      else if(datesArr.length === 1) {
        return [datesArr[0].toISOString().split('T')[0]];
      }
      else {
        return [datesArr[0].toISOString().split('T')[0], datesArr[datesArr.length-1].toISOString().split('T')[0]];
      }
    }
    else {
      return [];
    }
  }

  const dateRangeText = computed(()=> {
    return dateRange().join(" to ")
  });

  const dateRangeString = () => {
    return `_${dateRange().join('_-_')}`;
  }

  const filteredItems = computed(()=>{
    return  data.reports.filter((item) => {
      return item.name.toLowerCase().includes(data.search.toLowerCase()) && Permissions.checkPermissions([item.permission])
    })
  });

  const getCATCodes = () => {
    ApiWrapper.post('reports','get-cat-codes',{})
        .then((response) => {
          data.catcodes = response.queryClaims.map(function (obj) {
            return obj.catcode
          });
        })
        .catch((e)=>{
          ToastUtil.error(e);
        })
        .finally(()=>{
          data.dataLoading = false;
        })
  }

  const getClientNames = () => {
    ApiWrapper.post('reports','get-client-names',{})
        .then((response) => {
          data.companies = response.queryClients.map(function (obj) {
            return obj.name
          });
          data.companies.unshift('All Companies');

          //BG-NOTE: The '-All-' value is a special cases, and API accepts it
          data.clients = [{title: '-All-', key: ''}];

          response.queryClients.forEach((obj) => {
            if(obj.name && obj.name !== '') {
              data.clients.push({title: obj.name, key: obj.name});
            }
          });
        })
        .catch((e)=>{
          ToastUtil.error(e);
        })
        .finally(()=>{
          data.dataLoading = false;
        })
  }

  const getPaymentsData = () => {
    return new Promise((resolve, reject) => {
      ApiWrapper.post('reports', 'get-payments-data', {
        dateRange: dateRange()
      })
        .then((response) => {
          resolve(response.response);
        })
        .catch((e) => {
          ToastUtil.error(e);
          reject();
        });
    });
  }

  const getCycleTimeData = async () => {
    return new Promise((resolve, reject) => {
      const dateRangeVals = dateRange();
      if(dateRangeVals !== null && dateRangeVals.length === 2) {
        ApiWrapper.post('reports','get-cycle-time-data', {
          dates: dateRangeVals,
          report: data.cycleReportType,
          clientName: data.selectedClient,
          states: data.stateSelection
        })
            .then((response) => {
              resolve(response.response);
            })
            .catch((e)=>{
              ToastUtil.error(e);
              reject();
            });
      }
      else {
        reject();
      }
    });
  }

  // Given a json report, pulls the header names out based on 'key' and sets up row array
  const parseJsonReport = (reportData, labels = null) => {
    let headers = [];
    let rows = [];

    if(reportData !== null) {
      reportData?.forEach((reportRow) => {
        // Pull header info out if no header is set
        if (headers.length === 0) {
          for (const [key, value] of Object.entries(reportRow)) {
            const label = labels !== null ? labels[key] || key: key;
            headers.push(label);
          }
        }

        let row = [];
        for (const [key, value] of Object.entries(reportRow)) {
          let val = value;
          row.push(val);
        }
        rows.push(row);
      })
    }

    return {
      headers: headers,
      rows: rows
    }
  }

  const getReportData = () => {
    return new Promise((resolve, reject) => {
      ApiWrapper.post('reports','get-report-data', {
        report: data.report,
        selectedCompany: data.selectedCompany
      })
          .then((response) => {
            resolve(response.response);
          })
          .catch((e)=>{
            ToastUtil.error(e);
            reject();
          });
    });
  }

  const downloadAdjusterDailyReport = async () => {
    data.loading = true;
    data.isDisabled = true;

    await getReportData()
        .then((dataResp) => {
          const parsedReport = parseJsonReport(dataResp);

          if(parsedReport.headers.length === 0) {
            ToastUtil.error(`There is no data for this report`);
          }
          else {
            const rows = [];
            rows.push(parsedReport.headers);
            rows.push(...parsedReport.rows);
            downloadCSV(`adjuster_claims.csv`, ``, rows);
          }
        });

    data.loading = false;
    data.isDisabled = false;
  }

  const getAgingReceivablesData = () => {
    return new Promise((resolve, reject) => {
      ApiWrapper.post('reports', 'get-aging-receivables-data', {})
          .then((response) => {
            resolve(response.data);
          })
          .catch((e) => {
            ToastUtil.error(e);
            reject();
          });
    });
  }

  const downloadAgingReceivablesReport = async () => {
    data.loading = true;
    data.isDisabled = true;

    const labels = {
      internal_claim_id: "Internal Claim ID",
      internal_invoice_id: "Internal Invoice ID",
      invoice_num: "Invoice Number",
      age: "Age",
      date_generated: "Date Generated",
      amount: "Amount",
      payments: "Payments",
      balance: "Balance",
      claim_number: "Claim Number",
      insured: "Insured",
      insurance_company: "Insurance Company",
      representative: "Representative",
      rep_email: "Representative Email",
      lastcontact: "Last Contact",
      contactnotes: "Contact Notes"
    };

    await getAgingReceivablesData()
        .then((dataResp) => {
          const parsedReport = parseJsonReport(dataResp, labels);

          if(parsedReport.headers.length === 0) {
            ToastUtil.error(`There is no data for this report`);
          }
          else {
            const rows = [];
            rows.push(parsedReport.headers);
            rows.push(...parsedReport.rows);
            downloadCSV(`aging_receivables_report.csv`, ``, rows);
          }
        });

    data.loading = false;
    data.isDisabled = false;
  }

  const getBillingData = () => {
    return new Promise((resolve, reject) => {
      ApiWrapper.post('reports', 'get-billing-data', {
        report: data.report,
        selectedCompanyBilling: data.selectedCompanyBilling,
        dates: dateRange()
      })
          .then((response) => {
            let billing = response.response;
            billing.forEach(function (arrayItem) {
              if (arrayItem.amount !== null && arrayItem.amount.includes('$')) {
                arrayItem.amount = arrayItem.amount.replace(/\$/g, '');
              }
            });
            billing.forEach(function (arrayItem) {
              if (arrayItem.payments !== null && arrayItem.payments.includes('$')) {
                arrayItem.payments = arrayItem.payments.replace(/\$/g, '');
              }
            });
            data.dates = [];

            resolve(billing);
          })
          .catch((e) => {
            ToastUtil.error(e);
            reject();
          });
    });
  }

  const downloadBillingReport = async () => {
    data.loading = true;
    data.isDisabled = true;

    const labels = {
      claim_number: "Claim Number",
      name: "Name",
      representative: "Representative",
      amount: "Amount",
      payments: "Payments",
      invoice_date: "Invoice Date",
      invoice_number: "Invoice Number",
      fromxact: "From Xact",
      paymenttypecode: "Payment Type Code",
      paymentcoveragecode: "Payment Coverage Code",
      expensecode: "Expense Code",
      clientid: "Client ID"
    };

    await getBillingData()
        .then((dataResp) => {
          const parsedReport = parseJsonReport(dataResp, labels);

          if(parsedReport.headers.length === 0) {
            ToastUtil.error(`There is no data for this report`);
          }
          else {
            const rows = [];
            rows.push(parsedReport.headers);
            rows.push(...parsedReport.rows);
            downloadCSV(`billing_report.csv`, ``, rows);
          }
        });

    data.loading = false;
    data.isDisabled = false;
  }

  const getCatCodeData = () => {
    return new Promise((resolve, reject) => {
      ApiWrapper.post('reports', 'get-cat-code-data', {
        catcode: data.selectedCATCode,
      })
          .then((response) => {
            resolve(response.response);
          })
          .catch((e) => {
            ToastUtil.error(e);
            reject();
          })
    });
  }

  const downloadCatCodeReport = async () => {
    data.loading = true;
    data.isDisabled = true;

    await getCatCodeData()
        .then((dataResp) => {
          const parsedReport = parseJsonReport(dataResp);

          if(parsedReport.headers.length === 0) {
            ToastUtil.error(`There is no data for this report`);
          }
          else {
            const rows = [];
            rows.push(parsedReport.headers);
            rows.push(...parsedReport.rows);
            downloadCSV(`cat_code_report.csv`, ``, rows);
          }
        });

    data.loading = false;
    data.isDisabled = false;
  }


const getDisbursementTotalsData = () => {
  return new Promise((resolve, reject) => {
    ApiWrapper.post('reports', 'get-disbursement-totals', {
      dates: dateRange()
    })
        .then((response) => {
          let disbursementTotals = response.response;
          data.dates = [];

          resolve(disbursementTotals);
        })
        .catch((e) => {
          ToastUtil.error(e);
          reject();
        });
  });
}

const downloadDisbursementTotalsReport = async () => {
  data.loading = true;
  data.isDisabled = true;

  const labels = {
    type: "Type",
    total: "Total"
  };

  // const labelsNonFlatRate = {
  //   type: "Type",
  //   total: "Total"
  // };
  //
  // const labelsFlatRate = {
  //   total: "Total",
  //   percentage: "Percentage",
  //   roles: "Roles"
  // };

  await getDisbursementTotalsData()
      .then((dataResp) => {
        const parsedReport = parseJsonReport(dataResp.totals, labels);

        if(parsedReport.headers.length === 0) {
          ToastUtil.error(`There is no data for this report`);
        }
        else {
          const rows = [];
          rows.push(parsedReport.headers);
          rows.push(...parsedReport.rows);
          downloadCSV(`Disbursements_Report.csv`, ``, rows);
        }

        // const parsedReportNonFlatRate = parseJsonReport(dataResp.nonFlatRate, labelsNonFlatRate);
        //
        // if(parsedReportNonFlatRate.headers.length === 0) {
        //   ToastUtil.error(`There is no data for this report`);
        // }
        // else {
        //   const rows = [];
        //   rows.push(parsedReportNonFlatRate.headers);
        //   rows.push(...parsedReportNonFlatRate.rows);
        //   downloadCSV(`Non_Flat_Rate_report.csv`, ``, rows);
        // }
        //
        // const parsedReportFlatRate = parseJsonReport(dataResp.flatRate, labelsFlatRate);
        //
        // if(parsedReportFlatRate.headers.length === 0) {
        //   ToastUtil.error(`There is no data for this report`);
        // }
        // else {
        //   const rows = [];
        //   rows.push(parsedReportFlatRate.headers);
        //   rows.push(...parsedReportFlatRate.rows);
        //   downloadCSV(`Flat_Rate_report.csv`, ``, rows);
        // }
      });

  data.loading = false;
  data.isDisabled = false;
}

  const getOpenClaimsData = () => {
    return new Promise((resolve, reject) => {
      ApiWrapper.post('reports', 'get-open-claims-data', {})
          .then((response) => {
            resolve(response.data);
          })
          .catch((e) => {
            ToastUtil.error(e);
            reject();
          })
    });
  }

  const downloadOpenClaimsReport = async () => {
    data.loading = true;
    data.isDisabled = true;

    await getOpenClaimsData()
        .then((dataResp) => {
          const parsedReport = parseJsonReport(dataResp);
          if(parsedReport.headers.length === 0) {
            ToastUtil.error(`There is no data for this report`);
          }
          else {
            const rows = [];
            rows.push(parsedReport.headers);
            rows.push(...parsedReport.rows);
            downloadCSV(`open_claims.csv`, ``, rows);
          }
        });

    data.loading = false;
    data.isDisabled = false;
  }

  const getMetLifeData = () => {
    return new Promise((resolve, reject) => {
      ApiWrapper.post('reports', 'get-met-life-data', {
        dates: dateRange()
      })
          .then((response) => {
            resolve(response.data);
          })
          .catch((e) => {
            ToastUtil.error(e);
            reject();
          });
    });
  }

  const downloadMetlifeReport = async () => {
    data.loading = true;
    data.isDisabled = true;

    await getMetLifeData()
        .then((dataResp) => {
          const parsedReport = parseJsonReport(dataResp);
          if(parsedReport.headers.length === 0) {
            ToastUtil.error(`There is no data for this report`);
          }
          else {
            const rows = [];
            rows.push(parsedReport.headers);
            rows.push(...parsedReport.rows);
            downloadCSV(`metlife_prior_loss_report.csv`, ``, rows);
          }
        });

    data.loading = false;
    data.isDisabled = false;
  }

  const getContactListData = () => {
    return new Promise((resolve, reject) => {
      ApiWrapper.post('reports', 'get-contact-list', {})
          .then((response) => {
            resolve(response.queryClaims);
          })
          .catch((e) => {
            ToastUtil.error(e);
            reject();
          })
    });
  }

  const downloadContactListReport = async () => {
    data.loading = true;
    data.isDisabled = true;

    await getContactListData()
        .then((dataResp) => {
          const parsedReport = parseJsonReport(dataResp);
          if(parsedReport.headers.length === 0) {
            ToastUtil.error(`There is no data for this report`);
          }
          else {
            const rows = [];
            rows.push(parsedReport.headers);
            rows.push(...parsedReport.rows);
            downloadCSV(`contact_list_report.csv`, ``, rows);
          }
        });

    data.loading = false;
    data.isDisabled = false;
  }

  const downloadPaymentsReport = async () => {
    data.loading = true;
    data.isDisabled = true;

    await getPaymentsData()
        .then((dataResp) => {
          const parsedReport = parseJsonReport(dataResp);
          if(parsedReport.headers.length === 0) {
            ToastUtil.error(`There is no data for this report`);
          }
          else {
            const rows = [];
            rows.push(parsedReport.headers);
            rows.push(...parsedReport.rows);
            downloadCSV(`PAYMENTS_REPORT${dateRangeString()}.csv`, ``, rows);
          }
        });

    data.loading = false;
    data.isDisabled = false;
  }

  const getInvoicesData = () => {
    return new Promise((resolve, reject) => {
      let states = data.stateSelection?.length === 0 ? data.states.map((state) => state.abbreviation) : data.stateSelection;
      ApiWrapper.post('reports', 'get-invoices-data', {
        dateRange: dateRange(),
        states: states
      })
          .then((response) => {
            resolve(response.response);
          })
          .catch((e) => {
            ToastUtil.error(e);
            reject();
          });
    });
  }

  const downloadInvoicesReport = async () => {
    data.loading = true;
    data.isDisabled = true;

    await getInvoicesData()
        .then((dataResp) => {
          const parsedReport = parseJsonReport(dataResp);
          if(parsedReport.headers.length === 0) {
            ToastUtil.error(`There is no data for this report`);
          }
          else {
            const rows = [];
            rows.push(parsedReport.headers);
            rows.push(...parsedReport.rows);
            downloadCSV(`INVOICES_REPORT${dateRangeString()}.csv`, ``, rows);
          }
        });

    data.loading = false;
    data.isDisabled = false;
  }

  const getStateSalesTaxData = () => {
    return new Promise((resolve, reject) => {
      const dateRangeVals = dateRange();
      ApiWrapper.post('reports', 'get-state-sales-tax-data', {
        dateRange: dateRangeVals,
        stateCode: data.stateSalesTaxStateSelection
      })
          .then((response) => {
            resolve(response.response);
          })
          .catch((e) => {
            ToastUtil.error(e);
            reject();
          });
    });
  }

  const downloadSalesTaxReport = async () => {
    data.loading = true;
    data.isDisabled = true;

    await getStateSalesTaxData()
        .then((dataResp) => {
          const parsedReport = parseJsonReport(dataResp);
          if(parsedReport.headers.length === 0) {
            ToastUtil.error(`There is no data for this report`);
          }
          else {
            const rows = [];
            rows.push(parsedReport.headers);
            rows.push(...parsedReport.rows);
            downloadCSV(`SALES_TAX_REPORT_${data.stateSalesTaxStateSelection}_${dateRangeString()}.csv`, ``, rows);
          }
        });

    data.loading = false;
    data.isDisabled = false;
  }

  const downloadCycleTimeReport = async () => {
    data.loading = true;
    data.isDisabled = true;

    await getCycleTimeData()
        .then((dataResp) => {
          const rows = [];
          // Header row
          rows.push([
            "Name",
            "Claims",
            "Avg Days Until Contact",
            "Avg Days Until Inspected",
            "Avg Days From Contacted to Inspected",
            "Avg Days Until Reviewer Assigned",
            "Avg Days From Inspected to Reviewer Assigned",
            //"Avg Days Until Reviewed",
            //"Avg Days From Reviewer Assigned to Reviewed",
            "Avg Days Until Closed",
            "Avg Days From Reviewed to Closed",
            //"Avg Days Until (Recent) Closed",
            //"Avg Days From Reviewed to (Recent) Closed"
          ]);
          // Content rows
          dataResp.forEach((row) => {
            rows.push([
              row.name,
              row.claims,
              row.avgdaysuntilcontacted,
              row.avgdaysuntilinspected,
              row.avgdaysfromcontactedtoinspected,
              row.avgdaysuntilreviewerassigned,
              row.avgdaysfrominspectedtoreviewerassigned,
              //row.avgdaysuntilreviewed,
              //row.avgdaysfromreviewerassignedtoreviewed,
              row.avgdaysuntiloriginalclosed,
              row.avgdaysfromreviewedtooriginalclosed,
              //row.avgdaysuntilrecentclosed,
              //row.avgdaysfromreviewedtorecentclosed
            ]);
          });
          downloadCSV(`CYCLE_TIME_REPORT_${dateRangeString()}.csv`, ``, rows);

          data.loading = false;
          data.isDisabled = false;
    });
  }

  const getMileageExpenseAndDisbursementsReport = async() => {
    return new Promise((resolve, reject) => {
      const dateRangeVals = dateRange();
      if(dateRangeVals !== null && dateRangeVals.length === 2){
        ApiWrapper.post('reports','get-mileage-expenses-and-disbursements-report', {
          dates: dateRangeVals,
          clientName: data.selectedClient,
        })
            .then((response) => {
              resolve(response.response);
            })
            .catch((e)=>{
              ToastUtil.error(e);
              reject();
            });
      }
      else {
        reject();
      }
    });
  }

  const downloadMileageExpenseAndDisbursementsReport = async() => {
    data.loading = true;
    data.isDisabled = true;

    await getMileageExpenseAndDisbursementsReport()
        .then((dataResp) => {
          const rows = [];
          // Header row
          rows.push([
            "Date Invoiced",
            "Invoice #",
            "Claim #",
            "Claim State",
            "Client",
            "Invoice Amount",
            "Expense - Flat Rate Fee",
            "Expense - Misc.",
            "Expense - Mileage",
            "Disbursement - Flat Rate Review",
            "Disbursement - Flat Rate Adjuster",
            "Disbursement - Non-billable Mileage",
            "Disbursement - Mileage",
            "Disbursement - Misc.",
            "Hidden Admin Fee",
            "Admin Fee",
            "Total Expenses",
            "Total Disbursements",
            "Profit Dollars",
            "Profit Percent",
          ]);
          // Content rows
          dataResp.forEach((row) => {
            rows.push([
              row.inv_date,
              row.invoice_num,
              row.claimnumber,
              row.claim_state,
              row.client,
              row.invoice_amount,
              row.expense_flat_rate_fee,
              row.expense_misc,
              row.expense_mileage,
              row.disb_flat_rate_fee_reviewer,
              row.disb_flat_rate_fee_adjuster,
              row.disb_non_billable_mileage,
              row.disb_mileage,
              row.disb_misc,
              row.hidden_admin_fee,
              row.admin_fee,
              row.total_expenses,
              row.total_disbursements,
              row.profit_dollars,
              row.profit_percent,

            ]);
          });
          let filename;
          if(data.selectedClient){
            filename = `MILEAGE_EXPENSE_AND_DISBURSEMENT_REPORT_${data.selectedClient}_${dateRangeString()}.csv`
          }
          else{
            filename = `MILEAGE_EXPENSE_AND_DISBURSEMENT_REPORT_${dateRangeString()}.csv`
          }
          downloadCSV(filename, ``, rows);

          data.loading = false;
          data.isDisabled = false;
        });


    data.loading = false;
    data.isDisabled = false;
  }

  const downloadCSV = (filename, title, rows) => {
    // CSV File
    let csvContent = ''

    if(title && title !== '') {
      csvContent += `${title}\n`;
    }

    csvContent += rows.map((row, index) => {
      return row.map((val) => {
        if (typeof val === 'string') {
          // Fix issue with line breaks
          val = val.replaceAll('\n', '\u2028').replaceAll('\r', '\u2029');
          if(val.includes(',')) {
            return `"${val.replace(/"/g, '""')}"`;
          }
        }
        else if(Array.isArray(val)) {
          return `"${val.join(',')}"`;
        }

        return val;
      }).join(',');
    })
    .join('\n');

    const blob = new Blob(["\uFEFF"+csvContent], { type: 'text/csv;charset=utf-8' });

    const data = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.setAttribute('href', data)
    link.setAttribute('download', filename);
    link.click()
  }

  const selectReport = (item) => {
    const reportName = item.name;

    data.selectedCompany = '';
    data.selectedClient = '';
    data.cycleReportType = 'state';
    data.date = new Date();
    data.dates = [];
    data.datePreset = 'last-month';
    updateDatePreset();
    data.loading = false;

    data.report = reportName;
  }

  // Get number of days in a given month
  const daysInMonth = (month, year) => {
    return new Date(year, month, 0).getDate();
  }

  // Set the date range based on predefined range presets
  const updateDatePreset = () => {
    data.dates=[];

    const date = new Date();
    const currentDay = date.getDate();
    const currentMonth = date.getMonth();
    const currentYear = date.getFullYear();

    // First day of range
    let startDay = currentDay;
    let startMonth = currentMonth;
    let startYear = currentYear;

    // Last day of range
    let endDay = currentDay;
    let endMonth = currentMonth;
    let endYear = currentYear;

    switch(data.datePreset) {
      // If today is June 4, then this range should be (June 1 to June 4)
      case 'this-month':
          startDay = 1;
        break;
      // If today is June 4, then this range should be (May 4 to June 4)
      case 'last-month':
          // Subtract month by 1, if current month is January then go back to December
          startMonth = currentMonth > 0 ? currentMonth - 1 : 11;
          // Current month is January, go back to last year
          startYear = currentMonth === 0 ? startYear - 1 : startYear;
        break;
      // If today is June 4, then this range should be (May 1 to May 31)
      case 'previous-month':
          startDay = 1;
          // Subtract month by 1, if current month is January then go back to December
          startMonth = currentMonth > 0 ? currentMonth - 1 : 11;
          // Current month is January, go back to last year
          startYear = currentMonth === 0 ? startYear - 1 : startYear;

          // End day should be last day of month
          endDay = daysInMonth(startMonth, startYear);
          // Subtract month by 1, if current month is January then go back to December
          endMonth = currentMonth > 0 ? currentMonth - 1 : 11;
          // Current month is January, go back to last year
          endYear = currentMonth === 0 ? startYear - 1 : startYear;
        break;

      // If today is June 4 2025, then this range should be (January 1 2025 to June 4 2025)
      case 'this-year':
          startDay = 1;
          startMonth = 0;
        break;
      // If today is June 4 2025, then this range should be (June 4 2024 to June 4 2025)
      case 'last-year':
          startYear = currentYear-1;
        break;
      // If today is June 4 2025, then this range should be (January 1 2024 to December 31 2024)
      case 'previous-year':
          startMonth = 0;
          startDay = 1;
          startYear = currentYear-1;

          endMonth = 11;
          endDay = 31;
          endYear = currentYear-1;
        break;

      case 'custom':
        return;
    }

    const startDate = `${startYear}-${startMonth+1}-${startDay}`;
    const endDate = `${endYear}-${endMonth+1}-${endDay}`;
    data.dates = [startDate, endDate];
  }

  onMounted(()=>{
    // Load data that is needed for filtering reports
    if(Permissions.checkPermissions(['reports.client-name-list'])) {
      getClientNames();
    }
    if(Permissions.checkPermissions(['reports.cat-code-list'])) {
      getCATCodes();
    }
  })

</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-toolbar-title>Reports</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-progress-linear
            :active="data.loading"
            :indeterminate="data.loading"
            absolute
            bottom
            color="primary"
        ></v-progress-linear>
      </v-toolbar>

      <div v-if="typeof data.report === 'string' && data.report">
        <v-row align="start">
          <v-col cols="12">

            <!-- Adjuster Daily Report -->
            <v-card v-if="data.report === 'Adjuster Daily Report'">
              <v-card-title>
                {{data.report}}
              </v-card-title>

              <v-row
                  align="start"
              >
                <v-col cols="6" class="pb-0 pt-1">
                  <v-autocomplete
                      class="px-3 remove__extra__space"
                      v-model="data.selectedCompany"
                      :items="data.companies"
                      label="Type or select company's name or select All Companies"
                      prepend-icon="mdi-arrow-right-thick"
                  ></v-autocomplete>
                </v-col>
              </v-row>

              <v-card-title>
                <span class="ml-4">
                    <v-btn
                        size="small"
                        variant="elevated"
                        color="success"
                        :disabled="data.loading || data.isDisabled || !data.selectedCompany"
                        :loading="data.loading"
                        @click="downloadAdjusterDailyReport()"
                    >
                      <v-icon class="mr-2">mdi-file-download</v-icon>
                      Download CSV
                    </v-btn>
                </span>
              </v-card-title>
            </v-card>

            <!-- Aging Receivables Report -->
            <v-card v-if="data.report === 'Aging Receivables Report'">
              <v-card-title>
                {{data.report}}
              </v-card-title>

              <v-card-title>
                <span class="ml-4">
                  <v-btn
                      size="small"
                      variant="elevated"
                      color="success"
                      :disabled="data.loading || data.isDisabled"
                      :loading="data.loading"
                      @click="downloadAgingReceivablesReport()"
                  >
                    <v-icon class="mr-2">mdi-file-download</v-icon>
                    Download CSV
                  </v-btn>
                </span>
              </v-card-title>
            </v-card>

            <!-- Contact List Report -->
            <v-card class="py-0" v-if="data.report === 'Contact List Report'">
              <v-card-title>
                {{data.report}}
              </v-card-title>

              <v-card-title>
                <span class="ml-4">
                  <v-btn
                      size="small"
                      variant="elevated"
                      color="success"
                      :disabled="data.loading || data.isDisabled"
                      :loading="data.loading"
                      @click="downloadContactListReport()"
                  >
                    <v-icon class="mr-2">mdi-file-download</v-icon>
                    Download CSV
                  </v-btn>
                </span>
              </v-card-title>
            </v-card>

            <!-- Billing Report -->
            <v-card v-if="data.report === 'Billing Report'">
              <v-card-title>
                {{data.report}}
              </v-card-title>

              <v-row align="start">
                <v-col cols="6" class="pb-0 pt-1">
                  <v-autocomplete
                      class="px-3 remove__extra__space"
                      v-model="data.selectedCompanyBilling"
                      :items="data.companies"
                      label="Type or select company's name or select All Companies"
                      prepend-icon="mdi-arrow-right-thick"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <div v-if="data.selectedCompanyBilling?.length !== 0">
                <v-row align="start">
                  <v-col
                      cols="4"
                  >
                    <v-text-field
                        v-model="dateRangeText"
                        label="Date Range Preview"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        readonly
                        class="ml-3"
                    ></v-text-field>

                    <v-select
                        v-model="data.datePreset"
                        :items="data.datePresets"
                        prepend-icon="mdi-calendar-range"
                        class="ml-3"
                        item-title="title"
                        item-value="key"
                        label="Range Presets"
                        @update:modelValue="updateDatePreset"
                    ></v-select>

                    <v-date-picker
                        v-if="data.datePreset === 'custom'"
                        v-model="data.dates"
                        range
                        multiple="range"
                        show-current
                        class="ml-4 elevation-2"
                    >
                    </v-date-picker>
                  </v-col>
                </v-row>
              </div>
              <v-card-title>
                <span class="ml-4">
                    <v-btn
                        size="small"
                        variant="elevated"
                        color="success"
                        :disabled="data.loading || data.isDisabled || !data.selectedCompanyBilling || !Array.isArray(data.dates) || data.dates.length < 2"
                        :loading="data.loading"
                        @click="downloadBillingReport()"
                    >
                      <v-icon class="mr-2">mdi-file-download</v-icon>
                      Download CSV
                    </v-btn>
                </span>
              </v-card-title>
            </v-card>

            <!-- CAT Code Report -->
            <v-card v-if="data.report === 'CAT Code Report'">
              <v-card-title>
                {{data.report}}
              </v-card-title>

              <v-row
                  align="start"
              >
                <v-col cols="6" class="pb-0 pt-1">
                  <v-autocomplete
                      class="px-3 remove__extra__space"
                      v-model="data.selectedCATCode"
                      :items="data.catcodes"
                      label="Type or select CAT Code"
                      prepend-icon="mdi-arrow-right-thick"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-card-title>
                <span class="ml-4">
                  <v-btn
                      size="small"
                      variant="elevated"
                      color="success"
                      :disabled="data.loading || data.isDisabled || !data.selectedCATCode"
                      :loading="data.loading"
                      @click="downloadCatCodeReport()"
                  >
                    <v-icon class="mr-2">mdi-file-download</v-icon>
                    Download CSV
                  </v-btn>
                </span>
              </v-card-title>
            </v-card>

            <!-- Disbursement Totals Report -->
            <v-card v-if="data.report === 'Disbursement Totals Report'">
              <v-card-title>
                <span class="ml-4">
                  {{data.report}}
                </span>
                <v-row align="start">
                  <v-col
                      cols="4"
                  >
                    <v-text-field
                        v-model="dateRangeText"
                        label="Date Range Preview"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        readonly
                        class="ml-3"
                    ></v-text-field>

                    <v-select
                        v-model="data.datePreset"
                        :items="data.datePresets"
                        prepend-icon="mdi-calendar-range"
                        class="ml-3"
                        item-title="title"
                        item-value="key"
                        label="Range Presets"
                        @update:modelValue="updateDatePreset"
                    ></v-select>

                    <v-date-picker
                        v-if="data.datePreset === 'custom'"
                        v-model="data.dates"
                        range
                        multiple="range"
                        show-current
                        class="ml-4 elevation-2"
                    >
                    </v-date-picker>
                  </v-col>
                </v-row>
                <v-row align="start">
                  <v-col cols="4">
                  <span class="ml-4">
                    <v-btn
                        size="small"
                        variant="elevated"
                        color="success"
                        :disabled="data.loading || data.isDisabled"
                        :loading="data.loading"
                        @click="downloadDisbursementTotalsReport()"
                    >
                      <v-icon class="mr-2">mdi-file-download</v-icon>
                      Download CSV
                    </v-btn>
                  </span>
                  </v-col>
                </v-row>
              </v-card-title>
            </v-card>

            <!-- MetLife Prior Loss Report -->
            <div v-if="data.report === 'MetLife Prior Loss Report'">
              <v-card-title>
                {{data.report}}
              </v-card-title>
              <v-row align="start">
                <v-col
                    cols="4"
                >
                  <v-text-field
                      v-model="dateRangeText"
                      label="Date Range Preview"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      readonly
                      class="ml-3"
                  ></v-text-field>

                  <v-select
                      v-model="data.datePreset"
                      :items="data.datePresets"
                      prepend-icon="mdi-calendar-range"
                      class="ml-3"
                      item-title="title"
                      item-value="key"
                      label="Range Presets"
                      @update:modelValue="updateDatePreset"
                  ></v-select>

                  <v-date-picker
                      v-if="data.datePreset === 'custom'"
                      v-model="data.dates"
                      range
                      multiple="range"
                      show-current
                      class="ml-4 elevation-2"
                  >
                  </v-date-picker>
                </v-col>
              </v-row>
              <v-card-title class="py-0">
                <span class="ml-4">
                  <v-btn
                      size="small"
                      variant="elevated"
                      color="success"
                      :disabled="data.loading || data.isDisabled || !Array.isArray(data.dates) || data.dates.length < 2"
                      :loading="data.loading"
                      @click="downloadMetlifeReport()"
                  >
                    <v-icon class="mr-2">mdi-file-download</v-icon>
                    Download CSV
                  </v-btn>
                </span>
              </v-card-title>
            </div>

            <!-- Open Claims Report -->
            <v-card v-if="data.report === 'Open Claims Report'">
              <v-card-title>
                {{data.report}}

                <v-row>
                  <v-col cols="4">
                    <span class="ml-4">
                      <v-btn
                          size="small"
                          variant="elevated"
                          color="success"
                          :disabled="data.loading || data.isDisabled"
                          :loading="data.loading"
                          @click="downloadOpenClaimsReport()"
                      >
                        <v-icon class="mr-2">mdi-file-download</v-icon>
                        Download CSV
                      </v-btn>
                    </span>
                  </v-col>
                </v-row>
              </v-card-title>
            </v-card>

            <!-- Payments Report -->
            <v-card v-if="data.report === 'Payments Report'">
              <v-card-title>
                Payments Report

                <v-row>
                  <v-col cols="4">
                    <v-text-field
                        v-model="dateRangeText"
                        label="Date Range Preview"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        readonly
                        class="ml-3"
                    ></v-text-field>

                    <v-select
                        v-model="data.datePreset"
                        :items="data.datePresets"
                        prepend-icon="mdi-calendar-range"
                        class="ml-3"
                        item-title="title"
                        item-value="key"
                        label="Range Presets"
                        @update:modelValue="updateDatePreset()"
                    ></v-select>

                    <v-date-picker
                        v-if="data.datePreset === 'custom'"
                        show-adjacent-months
                        no-title
                        elevation="1"
                        multiple="range"
                        v-model="data.dates"
                    >
                    </v-date-picker>
                    <span class="ml-4">
                      <v-btn
                          size="small"
                          variant="elevated"
                          color="success"
                          :disabled="data.loading || data.isDisabled || !Array.isArray(data.dates) || data.dates.length < 2"
                          :loading="data.loading"
                          @click="downloadPaymentsReport()"
                      >
                        <v-icon class="mr-2">mdi-file-download</v-icon>
                        Download CSV
                      </v-btn>
                    </span>
                  </v-col>
                </v-row>
              </v-card-title>
            </v-card>

            <!-- Mileage Expenses and Disbursements Report -->
            <v-card v-if="data.report === 'Mileage Expenses and Disbursements Report'">
              <v-card-title>
                Mileage Expenses and Disbursements Report
                <v-row>
                  <v-col cols="4">
                    <v-text-field
                        v-model="dateRangeText"
                        label="Date Range Preview"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        readonly
                        class="ml-3"
                    ></v-text-field>

                    <v-select
                        v-model="data.datePreset"
                        :items="data.datePresets"
                        prepend-icon="mdi-calendar-range"
                        class="ml-3"
                        item-title="title"
                        item-value="key"
                        label="Range Presets"
                        @update:modelValue="updateDatePreset"
                    ></v-select>

                    <v-date-picker
                        v-if="data.datePreset === 'custom'"
                        v-model="data.dates"
                        range
                        multiple="range"
                        show-current
                        class="ml-4 elevation-2"
                    >
                    </v-date-picker>
                  </v-col>
                  <v-col cols="8">
                    <v-autocomplete
                        class="remove__extra__space"
                        v-model="data.selectedClient"
                        :items="data.clients"
                        label="(Optional) Select Company"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <span class="ml-4">
                    <v-btn
                        size="small"
                        variant="elevated"
                        color="success"
                        class="mt-2"
                        :disabled="data.loading || data.isDisabled || !Array.isArray(data.dates) || data.dates.length <= 1"
                        :loading="data.loading"
                        @click="downloadMileageExpenseAndDisbursementsReport()"
                    >
                      <v-icon class="mr-2">mdi-file-download</v-icon>
                      Download CSV
                    </v-btn>
                </span>
              </v-card-title>
            </v-card>

            <!-- Invoices Report -->
            <v-card v-if="data.report === 'Invoices Report'">
              <v-card-title>
                Invoices Report
                <v-row>
                  <v-col cols="4">
                    <v-text-field
                        v-model="dateRangeText"
                        label="Date Range Preview"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        readonly
                        class="ml-3"
                    ></v-text-field>

                    <v-select
                        v-model="data.datePreset"
                        :items="data.datePresets"
                        prepend-icon="mdi-calendar-range"
                        class="ml-3"
                        item-title="title"
                        item-value="key"
                        label="Range Presets"
                        @update:modelValue="updateDatePreset();"
                    ></v-select>

                    <v-date-picker
                        v-if="data.datePreset === 'custom'"
                        show-adjacent-months
                        no-title
                        elevation="1"
                        multiple="range"
                        v-model="data.dates"
                    >
                    </v-date-picker>
                  </v-col>
                  <v-col cols="8">
                    <v-select
                        v-model="data.stateSelection"
                        :items="data.states"
                        item-title="name"
                        item-value="abbreviation"
                        label="(Optional) Select States"
                        multiple
                    ></v-select>
                  </v-col>
                </v-row>
                <span class="ml-4">
                  <v-btn
                      size="small"
                      variant="elevated"
                      color="success"
                      :disabled="data.loading || data.isDisabled || !Array.isArray(data.dates) || data.dates.length < 2"
                      :loading="data.loading"
                      @click="downloadInvoicesReport()"
                  >
                    <v-icon class="mr-2">mdi-file-download</v-icon>
                    Download CSV
                  </v-btn>
                </span>
              </v-card-title>
            </v-card>

            <!-- State Sales Tax Report -->
            <v-card v-if="data.report === 'State Sales Tax Report'">
              <v-card-title>
                State Sales Tax Report
                <v-row>
                  <v-col cols="4">
                    <v-text-field
                        v-model="dateRangeText"
                        label="Date Range Preview"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        readonly
                        class="ml-3"
                    ></v-text-field>

                    <v-select
                        v-model="data.datePreset"
                        :items="data.datePresets"
                        prepend-icon="mdi-calendar-range"
                        class="ml-3"
                        item-title="title"
                        item-value="key"
                        label="Range Presets"
                        @update:modelValue="updateDatePreset();"
                    ></v-select>

                    <v-date-picker
                        v-if="data.datePreset === 'custom'"
                        show-adjacent-months
                        no-title
                        elevation="1"
                        multiple="range"
                        v-model="data.dates"
                    >
                    </v-date-picker>
                  </v-col>
                  <v-col cols="8">
                    <v-select
                        v-model="data.stateSalesTaxStateSelection"
                        :items="data.states.filter((state) => state.salesTax)"
                        item-title="name"
                        item-value="abbreviation"
                        label="Select State"
                    ></v-select>
                  </v-col>
                </v-row>
                <span class="ml-4">
                  <v-btn
                      size="small"
                      variant="elevated"
                      color="success"
                      :disabled="data.loading || data.isDisabled || !Array.isArray(data.dates) || data.dates.length < 2 || !data.stateSalesTaxStateSelection"
                      :loading="data.loading"
                      @click="downloadSalesTaxReport()"
                  >
                    <v-icon class="mr-2">mdi-file-download</v-icon>
                    Download CSV
                  </v-btn>
                </span>
              </v-card-title>
            </v-card>


            <!-- Cycle Time Report -->
            <v-card v-if="data.report === 'Cycle Time Report'">
              <v-card-title>
                Cycle Time Report
                <v-row>
                  <v-col cols="4">
                    <v-text-field
                        v-model="dateRangeText"
                        label="Date Range Preview"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        readonly
                        class="ml-3"
                    ></v-text-field>

                    <v-select
                        v-model="data.datePreset"
                        :items="data.datePresets"
                        prepend-icon="mdi-calendar-range"
                        class="ml-3"
                        item-title="title"
                        item-value="key"
                        label="Range Presets"
                        @update:modelValue="updateDatePreset"
                    ></v-select>

                    <v-date-picker
                        v-if="data.datePreset === 'custom'"
                        v-model="data.dates"
                        range
                        multiple="range"
                        show-current
                        class="ml-4 elevation-2"
                    >
                    </v-date-picker>
                  </v-col>
                  <v-col cols="8">
                    <v-autocomplete
                        class="remove__extra__space"
                        v-model="data.selectedClient"
                        :items="data.clients"
                        label="(Optional) Select Company"
                    ></v-autocomplete>

                    <v-select
                        v-model="data.cycleReportType"
                        :items="data.cycleReportTypes"
                        item-title="title"
                        item-value="key"
                        label="Report Type"
                    ></v-select>

                    <v-select
                        v-model="data.stateSelection"
                        :items="data.states"
                        item-title="name"
                        item-value="abbreviation"
                        label="(Optional) Select States"
                        multiple
                    ></v-select>
                  </v-col>
                </v-row>
                <span class="ml-4">
                    <v-btn
                        size="small"
                        variant="elevated"
                        color="success"
                        class="mt-2"
                        :disabled="data.loading || data.isDisabled || !Array.isArray(data.dates) || data.dates.length <= 1"
                        :loading="data.loading"
                        @click="downloadCycleTimeReport()"
                    >
                      <v-icon class="mr-2">mdi-file-download</v-icon>
                      Download CSV
                    </v-btn>
                </span>
              </v-card-title>
            </v-card>

          </v-col>
        </v-row>
      </div>

      <!-- Search Bar -->
      <v-row>
        <v-col cols="6" class="pb-0">
          <v-text-field
              class="mx-4"
              type="text"
              v-model="data.search"
              label="Search Reports"
              prepend-inner-icon=" mdi-magnify"
              filled
          >
          </v-text-field>
        </v-col>
      </v-row>

      <!-- Report List -->
      <!-- <v-subheader>Select a report to Create CSV (Scroll to see more)</v-subheader> -->

      <v-divider></v-divider>
      <v-list class="v_list_search">
        <v-list-subheader>Select a report to Create CSV</v-list-subheader>
<!--        <v-list-group color="primary">-->
          <v-list-item
              v-for="(item, i) in filteredItems" :key="i"
              @click="selectReport(item)"
          >
            <v-list-item-title>
              {{item.name}}
            </v-list-item-title>
          </v-list-item>
<!--        </v-list-group>-->
      </v-list>

    </v-card>
  </v-container>
</template>

<style scoped>
  .container {
    padding: 5px;
  }
  [v-cloak] {
    display: none;
  }
  .transparent {
    background: rgba(0, 0, 0, 0);
  }
  /* This CSS rule sets a height for the report list and adds scrolling */
  /* .v_list_search {
    height: 200px;
    overflow-y: auto;
  } */
  .mdi-arrow-right-thick::before {
    color: #4CAF50 !important;
  }
  /* Removes the extra spacing under the search filter where text field detail props are applied. Remove this CSS rule if detail props need to be added. */
  .remove__extra__space .v-text-field__details {
    display: none !important;
  }
</style>